// data editor change type constants
export const DATA_EDITOR_SET = 'set' as const;
export const DATA_EDITOR_UNSET = 'unset' as const;
export const DATA_EDITOR_UPDATE = 'update' as const;
export const DATA_EDITOR_BATCH_UPDATE = 'batch_update' as const;
